var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoubleCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 10,
    viewBox: "0 0 18 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6256 1.79616C12.9287 1.4498 12.8936 0.923328 12.5472 0.62026C12.2008 0.317192 11.6744 0.35229 11.3713 0.698653L8.74603 3.69895C8.44296 4.04531 8.47806 4.57178 8.82442 4.87485C9.17079 5.17792 9.69726 5.14282 10.0003 4.79646L12.6256 1.79616Z",
    fill: "#9B9DAA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.126 1.79616C17.4291 1.4498 17.394 0.923328 17.0476 0.62026C16.7013 0.317192 16.1748 0.35229 15.8717 0.698653L9.88099 7.54522L6.57256 4.39433C6.23928 4.07693 5.7118 4.08979 5.3944 4.42307C5.07699 4.75634 5.08986 5.28382 5.42313 5.60123L6.32772 6.46274L5.38054 7.54522L2.07211 4.39433C1.73883 4.07693 1.21135 4.08979 0.893949 4.42307C0.576544 4.75634 0.589409 5.28382 0.922685 5.60123L4.86058 9.3516C5.02503 9.50823 5.2463 9.59095 5.47317 9.58062C5.70005 9.5703 5.91288 9.46782 6.06244 9.2969L7.53569 7.61319L9.36102 9.3516C9.52548 9.50823 9.74674 9.59095 9.97362 9.58062C10.2005 9.5703 10.4133 9.46782 10.5629 9.2969L17.126 1.79616Z",
    fill: "#9B9DAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleCheck);
export default __webpack_public_path__ + "static/media/doubleCheck.38c6bf06d3da43461d9b8c6a0cb76062.svg";
export { ForwardRef as ReactComponent };